import { LandingInterestRecommendationsBlock } from '../landing-interest-recommendations-block.large';
import type { useDesktopLandingData } from '../use-desktop-landing-data';

export function RandomInterestDiscoverySection({ data }: { data: ReturnType<typeof useDesktopLandingData> }) {
  const { actions, tags, visibleRandomInterestRecommendations } = data;
  if (!visibleRandomInterestRecommendations?.length) return null;
  return (
    <LandingInterestRecommendationsBlock
      onOpenOfferTag={actions.openOfferTag}
      recommendations={visibleRandomInterestRecommendations}
      tags={tags}
    />
  );
}
